import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X, CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Sofía', 'Lucía', 'Valentina', 'Camila', 'Martina', 'Florencia', 'Agustina', 'Julieta', 'Carla', 'Romina', 'Daniela', 'Belén', 'Micaela', 'Gabriela', 'Verónica', 'Antonella', 'Rocío'];
const PROVINCES = ['Buenos Aires', 'Córdoba', 'Santa Fe', 'Mendoza', 'Tucumán', 'Salta', 'Entre Ríos', 'Misiones', 'Chaco', 'Corrientes', 'Neuquén', 'Río Negro', 'Santiago del Estero', 'San Juan', 'Jujuy', 'La Pampa', 'Formosa', 'San Luis'];
const TIMES = ['hace un momento', 'hace 1 min', 'hace 2 min', 'hace 3 min'];
function randomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
interface Purchase {
  id: number;
  name: string;
  province: string;
  time: string;
}
export function SocialProofPopup() {
  const [purchase, setPurchase] = useState<Purchase | null>(null);
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    const showPopup = () => {
      setPurchase({
        id: Date.now(),
        name: randomItem(NAMES),
        province: randomItem(PROVINCES),
        time: randomItem(TIMES)
      });
      hideTimeout = setTimeout(() => setPurchase(null), 6000);
    };
    // First popup shortly after load
    const initialTimeout = setTimeout(showPopup, 4000);
    // Then every 12 seconds
    const interval = setInterval(showPopup, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, []);
  return <div className="fixed bottom-4 left-4 z-[100] pointer-events-none" data-id="element-253">
      <AnimatePresence data-id="element-254">
        {purchase && <motion.div key={purchase.id} initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 24
      }} role="status" aria-live="polite" className="pointer-events-auto relative flex items-center gap-3 bg-white rounded-2xl shadow-2xl border border-cream-dark p-3 pr-9 max-w-[300px]" data-id="element-255">
            <button type="button" onClick={() => setPurchase(null)} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-dark-light hover:text-dark transition-colors" data-id="element-256">
              <X className="w-3.5 h-3.5" data-id="element-257" />
            </button>

            <div className="flex-shrink-0 bg-coral/10 p-2.5 rounded-xl" data-id="element-258">
              <ShoppingBag className="w-5 h-5 text-coral" data-id="element-259" />
            </div>

            <div className="min-w-0" data-id="element-260">
              <p className="text-dark font-bold text-sm leading-tight" data-id="element-261">
                {purchase.name} de {purchase.province}
              </p>
              <p className="text-dark-light text-xs leading-snug" data-id="element-262">
                acaba de comprar el libro 🧠
              </p>
              <div className="flex items-center gap-1 mt-0.5" data-id="element-263">
                <CheckCircle2 className="w-3 h-3 text-teal flex-shrink-0" data-id="element-264" />
                <span className="text-[10px] text-teal font-medium" data-id="element-265">
                  Compra verificada · {purchase.time}
                </span>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}